'use client';

import { FC } from 'react';
import { BrandCategoryBannerStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { CategoryHeadline } from 'molecules/CategoryHeadline';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const BrandCategoryBanner: FC<
  IStoryBlokComponentProps<BrandCategoryBannerStoryblok>
> = ({ blok, story }) => {
  const { type } = useMediaQuery();
  const deviceType = type === 'mobile' ? 'mobile' : 'desktop'; // tablet is not supported

  const hero = blok[`${deviceType}Hero`];
  const logo = blok[`${deviceType}Logo`];

  if (!hero?.filename && !logo?.filename) {
    return <CategoryHeadline title={story.name} />;
  }

  return (
    <>
      <div className={styles.root}>
        {hero?.filename && (
          <Image
            className={styles.hero}
            src={hero.filename}
            alt={hero.alt ?? ''}
          />
        )}
        {logo?.filename && (
          <Image
            className={styles.logo}
            src={logo.filename}
            alt={logo.alt ?? ''}
          />
        )}
      </div>
      <CategoryHeadline title={story.name} />
    </>
  );
};
